import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from '../../models/restResponse.mode';
import { MeasureUnite } from '../../models/measureUnite.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MeasureUniteService {
  private readonly baseUrl = `${environment.base_url}/measure-unities`;
  
  constructor(private http: HttpClient) {}

  getAll(description: string, active: boolean | null, paginate: boolean, page: number | null): Observable<RestResponse<MeasureUnite[]>> {
    return this.http.get<RestResponse<MeasureUnite[]>>(`${this.baseUrl}/list?search=${description}&active=${active}&paginate=${paginate}&page=${page}`);
  }

  getById(id: number): Observable<RestResponse<MeasureUnite>> {
    return this.http.get<RestResponse<MeasureUnite>>(`${this.baseUrl}/find/${id}`);
  }

  create(measureUnite: MeasureUnite): Observable<MeasureUnite> {
    return this.http.post<MeasureUnite>(`${this.baseUrl}/save`, measureUnite);
  }

  update(id: number, measureUnite: MeasureUnite): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/update/${id}`, measureUnite);
  }

}
